import React from "react";
import { VisibilityContext } from "react-horizontal-scrolling-menu";

import { useGlobalInformationStore } from "@stores/global_informationStore";
import { noop } from "lodash";
export function LeftArrow() {
  const { isFirstItemVisible, scrollPrev, visibleItemsWithoutSeparators, initComplete } = React.useContext(VisibilityContext);
  const [disabled, setDisabled] = React.useState(!initComplete || (initComplete && isFirstItemVisible));
  const _isNextScrollNeeded = useGlobalInformationStore((state) => state._isNextScrollNeeded);
  const _setisNextScrollNeeded = useGlobalInformationStore((state) => state._setisNextScrollNeeded);

  React.useEffect(() => {
    console.log("LeftArrow.useEffect");
    // NOTE: detect if whole component visible
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

  return (
    !disabled && (
      <div className="arrow-wrapper">
        <i
          className="icon icon-chevron-left arrow-wrapper__circle-shape"
          onClick={() => {
            if (_isNextScrollNeeded) {
              _setisNextScrollNeeded(false);
            }
            scrollPrev();
          }}
        ></i>
      </div>
    )
  );
}

export function RightArrow(isNextScrollNeeded: boolean = false) {
  const _isNextScrollNeeded = useGlobalInformationStore((state) => state._isNextScrollNeeded);
  const _setisNextScrollNeeded = useGlobalInformationStore((state) => state._setisNextScrollNeeded);

  const { isLastItemVisible, scrollNext, visibleItemsWithoutSeparators } = React.useContext(VisibilityContext);
  const [disabled, setDisabled] = React.useState(!visibleItemsWithoutSeparators.length && isLastItemVisible);
  React.useEffect(() => {
    if (_isNextScrollNeeded) {
      scrollNext();
    }
  }, [_isNextScrollNeeded, scrollNext]);

  React.useEffect(() => {
    console.log("RightArrow.useEffect");
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleItemsWithoutSeparators.length]);

  return (
    !disabled && (
      <div className="arrow-wrapper">
        <i
          className="icon icon-chevron-right arrow-wrapper__circle-shape"
          onClick={() => {
            _isNextScrollNeeded ? _setisNextScrollNeeded(false) : noop();
            scrollNext();
          }}
        ></i>
        ;
      </div>
    )
  );
}
